import React, { useState } from 'react';

// Material UI
import { styled, useTheme } from '@mui/material/styles';
import { Box, Grid, Paper } from '@mui/material';

// Forms
import { useTextInput } from 'hooks/forms';
import { TextField } from '../../../components/ui/inputs';
import { SubmitButton } from 'components/ui/buttons';
import { CancelButton } from 'components/ui/buttons';

// Utility
import { useNotification } from 'context/notification';
import fetchExpresso from 'utility/fetchExpresso';

export default function UserFormPassword(props) {
    // Props
    const { onUpdate, onCancel, userId } = props;

    // State
    const [loading, setLoading] = useState(false);

    // Form Values
    const password1 = useTextInput();
    const password2 = useTextInput();

    // Hooks
    const { notify } = useNotification();
    const theme = useTheme();

    function handleSubmit() {
        if (loading) return null;

        // Error Handling
        let formHasError = false;

        if (password1.value.length === 0) {
            password1.setError('This field cannot be empty');
            formHasError = true;
        }

        if (password1.value !== password2.value || password2.value.length === 0) {
            password2.setError('Your passwords do not match');
            formHasError = true;
        }

        if (formHasError) {
            return null;
        }

        setLoading(true);

        fetchExpresso(`/apiv2/users/${userId}/auth`, {
            method: 'PUT',
            body: { password: password1.value },
        })
            .then((res) => {
                if (res.status === 200) {
                    notify.success('Updated password');
                    onUpdate();
                } else {
                    throw new Error();
                }
            })
            .catch(() => {
                notify.error('There was a problem updating users password');
                setLoading(false);
            });
    }

    return (
        <Box display="flex" justifyContent="center" width="100%">
            <Box
                display="flex"
                flexDirection="column"
                flexGrow={1}
                p={[2, 4]}
                maxWidth={theme.breakpoints.values.sm}
            >
                <FormContainer>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField {...password1.formProps} required label="Password" />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField {...password2.formProps} required label="Confirm Password" />
                        </Grid>
                    </Grid>

                    <Box display="flex" justifyContent="flex-end" mt={4}>
                        <CancelButton onClick={onCancel} disabled={loading}>
                            Cancel
                        </CancelButton>
                        <SubmitButton onClick={handleSubmit} disabled={loading}>
                            Save
                        </SubmitButton>
                    </Box>
                </FormContainer>
            </Box>
        </Box>
    );
}

const FormContainer = styled(Paper)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
}));
